module.exports = __webpack_public_path__ + "351888c96a654271612de906b76a9e87.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/sm_image_3.png
// module id = 158
// module chunks = 0